import React from 'react';
import Two from '../layouts/two';
import Form from './form';

class Contact extends React.Component {
    state = { activeTab: 1 }
    onTab = (activeTab) => this.setState({ activeTab });
    render() {        
        return <Two nbs="contact" title="CONTACT" bi="/images/backgrounds/phone.jpg">
            <section>
                <div className="w3-black" id="contact">
                    <div className="w3-container w3-content">
                        <Form {...this.props} />
                    </div>
                </div>
            </section>
        </Two>
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/contact/index.js